const importImage = (flagName: string) => {
  switch (flagName) {
    case 'af':
      return require('../assets/flags/af.png');

    case 'ax':
      return require('../assets/flags/ax.png');

    case 'al':
      return require('../assets/flags/al.png');

    case 'dz':
      return require('../assets/flags/dz.png');

    case 'as':
      return require('../assets/flags/as.png');

    case 'ad':
      return require('../assets/flags/ad.png');

    case 'ao':
      return require('../assets/flags/ao.png');

    case 'ai':
      return require('../assets/flags/ai.png');

    case 'ag':
      return require('../assets/flags/ag.png');

    case 'ar':
      return require('../assets/flags/ar.png');

    case 'am':
      return require('../assets/flags/am.png');

    case 'aw':
      return require('../assets/flags/aw.png');

    case 'au':
      return require('../assets/flags/au.png');

    case 'at':
      return require('../assets/flags/at.png');

    case 'az':
      return require('../assets/flags/az.png');

    case 'bs':
      return require('../assets/flags/bs.png');

    case 'bh':
      return require('../assets/flags/bh.png');

    case 'bd':
      return require('../assets/flags/bd.png');

    case 'bb':
      return require('../assets/flags/bb.png');

    case 'by':
      return require('../assets/flags/by.png');

    case 'be':
      return require('../assets/flags/be.png');

    case 'bz':
      return require('../assets/flags/bz.png');

    case 'bj':
      return require('../assets/flags/bj.png');

    case 'bm':
      return require('../assets/flags/bm.png');

    case 'bt':
      return require('../assets/flags/bt.png');

    case 'bo':
      return require('../assets/flags/bo.png');

    case 'bq':
      return require('../assets/flags/bq.png');

    case 'ba':
      return require('../assets/flags/ba.png');

    case 'bw':
      return require('../assets/flags/bw.png');

    case 'br':
      return require('../assets/flags/br.png');

    case 'io':
      return require('../assets/flags/io.png');

    case 'vg':
      return require('../assets/flags/vg.png');

    case 'bn':
      return require('../assets/flags/bn.png');

    case 'bg':
      return require('../assets/flags/bg.png');

    case 'bf':
      return require('../assets/flags/bf.png');

    case 'bi':
      return require('../assets/flags/bi.png');

    case 'kh':
      return require('../assets/flags/kh.png');

    case 'cm':
      return require('../assets/flags/cm.png');

    case 'ca':
      return require('../assets/flags/ca.png');

    case 'cv':
      return require('../assets/flags/cv.png');

    case 'ky':
      return require('../assets/flags/ky.png');

    case 'cf':
      return require('../assets/flags/cf.png');

    case 'td':
      return require('../assets/flags/td.png');

    case 'cl':
      return require('../assets/flags/cl.png');

    case 'cn':
      return require('../assets/flags/cn.png');

    case 'cx':
      return require('../assets/flags/cx.png');

    case 'cc':
      return require('../assets/flags/cc.png');

    case 'co':
      return require('../assets/flags/co.png');

    case 'km':
      return require('../assets/flags/km.png');

    case 'ck':
      return require('../assets/flags/ck.png');

    case 'cr':
      return require('../assets/flags/cr.png');

    case 'ci':
      return require('../assets/flags/ci.png');

    case 'hr':
      return require('../assets/flags/hr.png');

    case 'cu':
      return require('../assets/flags/cu.png');

    case 'cw':
      return require('../assets/flags/cw.png');

    case 'cy':
      return require('../assets/flags/cy.png');

    case 'cz':
      return require('../assets/flags/cz.png');

    case 'cd':
      return require('../assets/flags/cd.png');

    case 'dk':
      return require('../assets/flags/dk.png');

    case 'dj':
      return require('../assets/flags/dj.png');

    case 'dm':
      return require('../assets/flags/dm.png');

    case 'do':
      return require('../assets/flags/do.png');

    case 'ec':
      return require('../assets/flags/ec.png');

    case 'eg':
      return require('../assets/flags/eg.png');

    case 'sv':
      return require('../assets/flags/sv.png');

    case 'gq':
      return require('../assets/flags/gq.png');

    case 'er':
      return require('../assets/flags/er.png');

    case 'ee':
      return require('../assets/flags/ee.png');

    case 'sz':
      return require('../assets/flags/sz.png');

    case 'et':
      return require('../assets/flags/et.png');

    case 'fk':
      return require('../assets/flags/fk.png');

    case 'fo':
      return require('../assets/flags/fo.png');

    case 'fm':
      return require('../assets/flags/fm.png');

    case 'fj':
      return require('../assets/flags/fj.png');

    case 'fi':
      return require('../assets/flags/fi.png');

    case 'fr':
      return require('../assets/flags/fr.png');

    case 'gf':
      return require('../assets/flags/gf.png');

    case 'pf':
      return require('../assets/flags/pf.png');

    case 'ga':
      return require('../assets/flags/ga.png');

    case 'gm':
      return require('../assets/flags/gm.png');

    case 'ge':
      return require('../assets/flags/ge.png');

    case 'de':
      return require('../assets/flags/de.png');

    case 'gh':
      return require('../assets/flags/gh.png');

    case 'gi':
      return require('../assets/flags/gi.png');

    case 'gr':
      return require('../assets/flags/gr.png');

    case 'gl':
      return require('../assets/flags/gl.png');

    case 'gd':
      return require('../assets/flags/gd.png');

    case 'gp':
      return require('../assets/flags/gp.png');

    case 'gu':
      return require('../assets/flags/gu.png');

    case 'gt':
      return require('../assets/flags/gt.png');

    case 'gn':
      return require('../assets/flags/gn.png');

    case 'gw':
      return require('../assets/flags/gw.png');

    case 'gy':
      return require('../assets/flags/gy.png');

    case 'ht':
      return require('../assets/flags/ht.png');

    case 'hn':
      return require('../assets/flags/hn.png');

    case 'hk':
      return require('../assets/flags/hk.png');

    case 'hu':
      return require('../assets/flags/hu.png');

    case 'is':
      return require('../assets/flags/is.png');

    case 'in':
      return require('../assets/flags/in.png');

    case 'id':
      return require('../assets/flags/id.png');

    case 'ir':
      return require('../assets/flags/ir.png');

    case 'iq':
      return require('../assets/flags/iq.png');

    case 'ie':
      return require('../assets/flags/ie.png');

    case 'il':
      return require('../assets/flags/il.png');

    case 'it':
      return require('../assets/flags/it.png');

    case 'jm':
      return require('../assets/flags/jm.png');

    case 'jp':
      return require('../assets/flags/jp.png');

    case 'jo':
      return require('../assets/flags/jo.png');

    case 'kz':
      return require('../assets/flags/kz.png');

    case 'ke':
      return require('../assets/flags/ke.png');

    case 'ki':
      return require('../assets/flags/ki.png');

    case 'xk':
      return require('../assets/flags/xk.png');

    case 'kw':
      return require('../assets/flags/kw.png');

    case 'kg':
      return require('../assets/flags/kg.png');

    case 'la':
      return require('../assets/flags/la.png');

    case 'lv':
      return require('../assets/flags/lv.png');

    case 'lb':
      return require('../assets/flags/lb.png');

    case 'ls':
      return require('../assets/flags/ls.png');

    case 'lr':
      return require('../assets/flags/lr.png');

    case 'ly':
      return require('../assets/flags/ly.png');

    case 'li':
      return require('../assets/flags/li.png');

    case 'lt':
      return require('../assets/flags/lt.png');

    case 'lu':
      return require('../assets/flags/lu.png');

    case 'mo':
      return require('../assets/flags/mo.png');

    case 'mg':
      return require('../assets/flags/mg.png');

    case 'mw':
      return require('../assets/flags/mw.png');

    case 'my':
      return require('../assets/flags/my.png');

    case 'mv':
      return require('../assets/flags/mv.png');

    case 'ml':
      return require('../assets/flags/ml.png');

    case 'mt':
      return require('../assets/flags/mt.png');

    case 'mh':
      return require('../assets/flags/mh.png');

    case 'mq':
      return require('../assets/flags/mq.png');

    case 'mr':
      return require('../assets/flags/mr.png');

    case 'mu':
      return require('../assets/flags/mu.png');

    case 'yt':
      return require('../assets/flags/yt.png');

    case 'mx':
      return require('../assets/flags/mx.png');

    case 'md':
      return require('../assets/flags/md.png');

    case 'mc':
      return require('../assets/flags/mc.png');

    case 'mn':
      return require('../assets/flags/mn.png');

    case 'me':
      return require('../assets/flags/me.png');

    case 'ma':
      return require('../assets/flags/ma.png');

    case 'mz':
      return require('../assets/flags/mz.png');

    case 'mm':
      return require('../assets/flags/mm.png');

    case 'na':
      return require('../assets/flags/na.png');

    case 'nr':
      return require('../assets/flags/nr.png');

    case 'np':
      return require('../assets/flags/np.png');

    case 'nl':
      return require('../assets/flags/nl.png');

    case 'nc':
      return require('../assets/flags/nc.png');

    case 'nz':
      return require('../assets/flags/nz.png');

    case 'ni':
      return require('../assets/flags/ni.png');

    case 'ne':
      return require('../assets/flags/ne.png');

    case 'ng':
      return require('../assets/flags/ng.png');

    case 'nu':
      return require('../assets/flags/nu.png');

    case 'nf':
      return require('../assets/flags/nf.png');

    case 'kp':
      return require('../assets/flags/kp.png');

    case 'mk':
      return require('../assets/flags/mk.png');

    case 'mp':
      return require('../assets/flags/mp.png');

    case 'no':
      return require('../assets/flags/no.png');

    case 'om':
      return require('../assets/flags/om.png');

    case 'pk':
      return require('../assets/flags/pk.png');

    case 'pw':
      return require('../assets/flags/pw.png');

    case 'ps':
      return require('../assets/flags/ps.png');

    case 'pa':
      return require('../assets/flags/pa.png');

    case 'pg':
      return require('../assets/flags/pg.png');

    case 'py':
      return require('../assets/flags/py.png');

    case 'pe':
      return require('../assets/flags/pe.png');

    case 'ph':
      return require('../assets/flags/ph.png');

    case 'pn':
      return require('../assets/flags/pn.png');

    case 'pl':
      return require('../assets/flags/pl.png');

    case 'pt':
      return require('../assets/flags/pt.png');

    case 'pr':
      return require('../assets/flags/pr.png');

    case 'qa':
      return require('../assets/flags/qa.png');

    case 'cg':
      return require('../assets/flags/cg.png');

    case 're':
      return require('../assets/flags/re.png');

    case 'ro':
      return require('../assets/flags/ro.png');

    case 'ru':
      return require('../assets/flags/ru.png');

    case 'rw':
      return require('../assets/flags/rw.png');

    case 'bl':
      return require('../assets/flags/bl.png');

    case 'sh':
      return require('../assets/flags/sh.png');

    case 'kn':
      return require('../assets/flags/kn.png');

    case 'lc':
      return require('../assets/flags/lc.png');

    case 'mf':
      return require('../assets/flags/mf.png');

    case 'pm':
      return require('../assets/flags/pm.png');

    case 'vc':
      return require('../assets/flags/vc.png');

    case 'ws':
      return require('../assets/flags/ws.png');

    case 'sm':
      return require('../assets/flags/sm.png');

    case 'st':
      return require('../assets/flags/st.png');

    case 'sa':
      return require('../assets/flags/sa.png');

    case 'sn':
      return require('../assets/flags/sn.png');

    case 'rs':
      return require('../assets/flags/rs.png');

    case 'sc':
      return require('../assets/flags/sc.png');

    case 'sl':
      return require('../assets/flags/sl.png');

    case 'sg':
      return require('../assets/flags/sg.png');

    case 'sk':
      return require('../assets/flags/sk.png');

    case 'si':
      return require('../assets/flags/si.png');

    case 'sb':
      return require('../assets/flags/sb.png');

    case 'so':
      return require('../assets/flags/so.png');

    case 'za':
      return require('../assets/flags/za.png');

    case 'gs':
      return require('../assets/flags/gs.png');

    case 'kr':
      return require('../assets/flags/kr.png');

    case 'ss':
      return require('../assets/flags/ss.png');

    case 'es':
      return require('../assets/flags/es.png');

    case 'lk':
      return require('../assets/flags/lk.png');

    case 'sd':
      return require('../assets/flags/sd.png');

    case 'sr':
      return require('../assets/flags/sr.png');

    case 'sj':
      return require('../assets/flags/sj.png');

    case 'se':
      return require('../assets/flags/se.png');

    case 'ch':
      return require('../assets/flags/ch.png');

    case 'sy':
      return require('../assets/flags/sy.png');

    case 'tw':
      return require('../assets/flags/tw.png');

    case 'tj':
      return require('../assets/flags/tj.png');

    case 'tz':
      return require('../assets/flags/tz.png');

    case 'th':
      return require('../assets/flags/th.png');

    case 'tl':
      return require('../assets/flags/tl.png');

    case 'tg':
      return require('../assets/flags/tg.png');

    case 'tk':
      return require('../assets/flags/tk.png');

    case 'to':
      return require('../assets/flags/to.png');

    case 'tt':
      return require('../assets/flags/tt.png');

    case 'tn':
      return require('../assets/flags/tn.png');

    case 'tr':
      return require('../assets/flags/tr.png');

    case 'tm':
      return require('../assets/flags/tm.png');

    case 'tc':
      return require('../assets/flags/tc.png');

    case 'tv':
      return require('../assets/flags/tv.png');

    case 'ug':
      return require('../assets/flags/ug.png');

    case 'ua':
      return require('../assets/flags/ua.png');

    case 'ae':
      return require('../assets/flags/ae.png');

    case 'gb':
      return require('../assets/flags/gb.png');

    case 'us':
      return require('../assets/flags/us.png');

    case 'uy':
      return require('../assets/flags/uy.png');

    case 'uz':
      return require('../assets/flags/uz.png');

    case 'vu':
      return require('../assets/flags/vu.png');

    case 've':
      return require('../assets/flags/ve.png');

    case 'vn':
      return require('../assets/flags/vn.png');

    case 'wf':
      return require('../assets/flags/wf.png');

    case 'ye':
      return require('../assets/flags/ye.png');

    case 'zm':
      return require('../assets/flags/zm.png');

    case 'zw':
      return require('../assets/flags/zw.png');

    default:
      return require('../assets/unknown.png');
  }
};

export default importImage;
